import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'
import { ICONS } from '../../themes'

// Wrapper
// ============================================================
export const DatePickerInputStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  height: 42px;
  width: 200px;

  /* Child element styles
  ------------------------------- */
  .input-wrapper {
    position: relative;
    width: 100%;

    .calendar {
      width: 16px;
      position: absolute;
      right: 12px;
      top: 13px;
      /* z-index: 5; */
    }

    .react-datepicker__close-icon {
      width: 30px;
      background-color: white;
      padding: 0px 6px 0px 3px;
      border-radius: 6px;

      &:after {
        max-width: 16px;
        max-height: 16px;
        font-size: 25px;
        line-height: 13px;
        background-image: url(${ICONS['icon-calendar.png']});
        content: '';
        background-color: transparent;
        border-radius: 0;
      }
    }

    .react-datepicker {
      font-family: ${VARIABLES.TYPOGRAPHYS.FONT_FAMILIES.FIRST};
      display: flex;

      .react-datepicker__navigation {
        width: 19px;
        height: 19px;
        border: 0;
        margin: 0.5rem;

        &.react-datepicker__navigation--next {
          &:after {
            background-image: url(${ICONS['icon-chevron-right-circle.png']});
          }
        }

        &.react-datepicker__navigation--previous {
          &:after {
            background-image: url(${ICONS['icon-chevron-left-circle.png']});
          }
        }

        &:after {
          content: '';
          position: absolute;
          display: block;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }

      .react-datepicker__header {
        background-color: white;
      }

      .react-datepicker__current-month {
        display: none;
      }

      .react-datepicker__month-dropdown-container {
        position: relative;
        margin: 1px 5px 0;
        width: 95px;

        &:after {
          content: '';
          position: absolute;
          display: block;
          width: 7px;
          height: 4px;
          top: 8px;
          right: 0;
          background-size: contain;
          background-repeat: no-repeat;
          background-image: url(${ICONS['icon-chevron-down.png']});
        }
      }

      .react-datepicker__year-dropdown-container {
        position: relative;
        margin: 1px 5px 0;
        width: 50px;

        &:after {
          content: '';
          position: absolute;
          display: block;
          width: 7px;
          height: 4px;
          top: 8px;
          right: 0;
          background-size: contain;
          background-repeat: no-repeat;
          background-image: url(${ICONS['icon-chevron-down.png']});
        }
      }

      .react-datepicker__month-select,
      .react-datepicker__year-select {
        border: 0;
        color: ${VARIABLES.COLORS.BLUE_1};
        font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
        -moz-appearance: none; /* Firefox */
        -webkit-appearance: none; /* Safari and Chrome */
        appearance: none;
        width: 100%;
        position: relative;
        z-index: 2;
        background-color: transparent;
        height: 100%;
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
      }

      .react-datepicker__day-names {
      }

      .react-datepicker__header__dropdown {
        margin-bottom: 7px;
        display: flex;
        justify-content: center;
      }

      .react-datepicker__day-name,
      .react-datepicker__day,
      .react-datepicker__time-name {
        margin: 3px 6px;
        width: 24px;
        line-height: 24px;
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MN};
        color: ${VARIABLES.COLORS.BLUE_1};
      }

      .react-datepicker__day {
        &.react-datepicker__day--today {
          color: white;
          background-color: ${VARIABLES.COLORS.BLUE_6};
          border-radius: 0.3rem;
        }

        &.react-datepicker__day--selected,
        &.react-datepicker__day--in-selecting-range,
        &.react-datepicker__day--in-range,
        &.react-datepicker__month-text--selected,
        &.react-datepicker__month-text--in-selecting-range,
        &.react-datepicker__month-text--in-range,
        &.react-datepicker__quarter-text--selected,
        &.react-datepicker__quarter-text--in-selecting-range,
        &.react-datepicker__quarter-text--in-range,
        &.react-datepicker__year-text--selected,
        &.react-datepicker__year-text--in-selecting-range,
        &.react-datepicker__year-text--in-range,
        &.react-datepicker__day--keyboard-selected {
          color: white;
          background-color: ${VARIABLES.COLORS.BLUE_1};
        }
      }

      .react-datepicker__day--disabled,
      .react-datepicker__month-text--disabled,
      .react-datepicker__quarter-text--disabled,
      .react-datepicker__year-text--disabled {
        background-color: ${VARIABLES.COLORS.GRAY_1};
        border-radius: 0.3rem;
        color: ${VARIABLES.COLORS.GRAY_2};

        &:hover {
          background-color: ${VARIABLES.COLORS.GRAY_1};
          pointer-events: none;
        }
      }

      .react-datepicker__input-time-container {
        color: ${VARIABLES.COLORS.BLUE_1};

        .react-datepicker-time__caption {
          font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
        }

        .react-datepicker-time__input {
          input {
            border: 1px solid ${VARIABLES.COLORS.BLUE_1};
          }
        }
      }

      .react-datepicker__time-container {
        width: 100px;
        .react-datepicker-time__header {
          color: ${VARIABLES.COLORS.BLUE_1};
        }

        .react-datepicker__time {
          color: ${VARIABLES.COLORS.BLUE_1};

          .react-datepicker__time-box {
            width: 99px;
          }
        }
      }
    }
  }

  .react-datepicker-popper {
    z-index: 100;
  }

  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 112px;
  }

  .react-datepicker-wrapper {
    background-color: white;
    width: 100%;
    border-radius: 6px;
    border: 1px solid ${VARIABLES.COLORS.GRAY_2};
    height: 100%;
    box-sizing: border-box;
    display: flex;
    z-index: 2;
    position: relative;
    background-color: transparent;

    .react-datepicker__input-container {
      height: 100%;

      .date-picker-custom {
        border: 0;
        background: transparent;
        height: 100%;
        padding: 0 0 0 15px;
        font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};
        //color: ${VARIABLES.COLORS.BLUE_1};
        padding-right: 37px;
        box-sizing: border-box;
        width: 100%;
        color: ${VARIABLES.COLORS.GRAY_3};
        cursor: pointer;
        &:disabled {
          background-color: ${VARIABLES.COLORS.GRAY_8} !important;
          color: ${VARIABLES.COLORS.GRAY_10} !important;
          cursor: default;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */
  &.is-inline-datepicker {
    .input-wrapper {
      .react-datepicker {
        display: inline-block;
      }
    }
  }

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    height: 40px;
    /* width: 200px; */

    .react-datepicker-wrapper {
      .react-datepicker__input-container {
        .date-picker-custom {
          font-size: 16px;
          padding-right: 35px;
        }
      }
    }

    .input-wrapper {
      .calendar {
        width: 15px;
        right: 11px;
        top: 12px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    height: 38px;
    width: 180px;

    .react-datepicker-wrapper {
      .react-datepicker__input-container {
        .date-picker-custom {
          font-size: 15px;
          padding-right: 33px;
        }
      }
    }

    .input-wrapper {
      .calendar {
        width: 14px;
        right: 10px;
        top: 11px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    height: 36px;
    width: 175px;

    .react-datepicker-wrapper {
      .react-datepicker__input-container {
        .date-picker-custom {
          font-size: 14px;
          padding-right: 28px;
        }
      }
    }

    .input-wrapper {
      .calendar {
        width: 13px;
        right: 9px;
        top: 11px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    height: 34px;
    width: 170px;

    .react-datepicker-wrapper {
      .react-datepicker__input-container {
        .date-picker-custom {
          font-size: 13px;
          padding-right: 26px;
        }
      }
    }

    .input-wrapper {
      .calendar {
        width: 12px;
        right: 8px;
        top: 11px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    height: 32px;
    width: 145px;

    .react-datepicker-wrapper {
      .react-datepicker__input-container {
        .date-picker-custom {
          font-size: 12px;
          padding-right: 24px;
        }
      }
    }

    .input-wrapper {
      .calendar {
        width: 11px;
        right: 7px;
        top: 10px;
      }
    }
  }
`
